import { RefreshCw } from 'lucide-react';
import { useI18n, useVisibleCopy } from '../i18n';

export function RefreshActionButton({
  busyLabel,
  disabled = false,
  label,
  loading = false,
  onClick,
}: {
  busyLabel?: string;
  disabled?: boolean;
  label?: string;
  loading?: boolean;
  onClick: () => void | Promise<void>;
}) {
  const { t } = useI18n();
  const ui = useVisibleCopy();
  const accessibleLabel = ui(label ?? t('common.refreshLiveData'));
  const tooltip = accessibleLabel;

  return (
    <span className="refresh-action" data-tooltip={tooltip}>
      <button
        aria-busy={loading || undefined}
        aria-label={accessibleLabel}
        className={`btn btn-subtle btn-icon refresh-action-button${loading ? ' is-loading' : ''}`}
        disabled={disabled || loading}
        title={tooltip}
        type="button"
        onClick={() => { void onClick(); }}
      >
        <RefreshCw aria-hidden="true" focusable="false" size={18} strokeWidth={2.25} />
      </button>
    </span>
  );
}
